import { WarningCircle } from '@phosphor-icons/react';
import { StatusBadge, jd, yen } from './mktShared';

const COLUMNS = [
  { key: 'draft', label: '下書き', statuses: ['draft'], accent: 'bg-zinc-400' },
  { key: 'quote', label: '見積・承認待ち', statuses: ['quoted', 'approval_pending'], accent: 'bg-sky-500' },
  { key: 'approved', label: '客先承認済', statuses: ['approved'], accent: 'bg-emerald-500' },
  { key: 'production', label: '製造中', statuses: ['sent_to_seizo', 'in_production'], accent: 'bg-blue-500' },
  { key: 'inspection', label: '検査・出荷準備', statuses: ['qc_pending', 'qc_passed', 'ready_to_ship', 'partially_shipped'], accent: 'bg-violet-500' },
  { key: 'kansei', label: '売上確定待ち', statuses: ['shipped', 'completion_pending'], accent: 'bg-fuchsia-500' },
  { key: 'done', label: '完了', statuses: ['completed'], accent: 'bg-emerald-600' },
  { key: 'closed', label: '却下・中止', statuses: ['rejected', 'cancelled'], accent: 'bg-zinc-300', optional: true },
];

export default function OrdersKanban({ orders, loading, isOverdue, onOpen }) {
  if (loading) return <p className="py-10 text-center text-xs text-zinc-400">読み込み中…</p>;
  return (
    <div className="overflow-x-auto pb-2" data-testid="mkt-orders-kanban">
      <div className="flex gap-3 min-w-max">
        {COLUMNS.map((col) => {
          const items = orders.filter((o) => col.statuses.includes(o.status));
          if (col.optional && items.length === 0) return null;
          return (
            <div key={col.key} className="w-60 shrink-0 rounded-xl bg-zinc-100/70 p-2" data-testid={`mkt-kanban-col-${col.key}`}>
              <div className="flex items-center gap-2 px-1.5 py-1.5">
                <span className={`h-2 w-2 rounded-full ${col.accent}`} />
                <span className="text-xs font-semibold text-zinc-700">{col.label}</span>
                <span className="ml-auto rounded-full bg-white px-1.5 text-[10px] font-semibold text-zinc-500" data-testid={`mkt-kanban-count-${col.key}`}>{items.length}</span>
              </div>
              <div className="space-y-1.5">
                {items.length === 0 && <p className="px-1.5 py-4 text-center text-[10px] text-zinc-300">なし</p>}
                {items.map((o) => (
                  <button key={o.id} type="button" onClick={() => onOpen(o.id)} data-testid={`mkt-kanban-card-${o.id}`}
                    className="w-full rounded-lg border border-zinc-200 bg-white p-2.5 text-left shadow-sm transition-all hover:border-fuchsia-300 hover:shadow">
                    <div className="flex items-center justify-between gap-1">
                      <span className="font-mono text-[10px] font-semibold text-fuchsia-700">{o.order_no}</span>
                      <StatusBadge status={o.status} label={o.status_label} className="!text-[9px] !px-1.5" />
                    </div>
                    <div className="mt-1 truncate text-xs font-medium text-zinc-800">{o.title || '（件名なし）'}</div>
                    <div className="truncate text-[10px] text-zinc-500"><span data-no-translate>{o.customer_name}</span></div>
                    <div className="mt-1.5 flex items-center justify-between">
                      <span className={`text-[10px] tabular-nums ${isOverdue(o) ? 'font-semibold text-red-600' : 'text-zinc-400'}`}>
                        {isOverdue(o) && <WarningCircle size={11} weight="fill" className="inline mr-0.5 -mt-0.5" />}{jd(o.due_date)}
                      </span>
                      <span className="text-[10px] font-semibold tabular-nums text-zinc-600">{yen(o.total)}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
